var map = {
	"./backgammon.svg": 397,
	"./betFights.svg": 398,
	"./betShopClient.svg": 399,
	"./betShopPocket.svg": 400,
	"./bettingGames.svg": 401,
	"./casinoSuite.svg": 402,
	"./fantasySports.svg": 403,
	"./financialBetting.svg": 404,
	"./friendShip.svg": 405,
	"./hilo.svg": 406,
	"./liveCasino.svg": 407,
	"./liveMonitor.svg": 408,
	"./liveScoutData.svg": 409,
	"./liveSports.svg": 410,
	"./oddsFeed.svg": 411,
	"./poker.svg": 412,
	"./predictor.svg": 413,
	"./skillGames.svg": 414,
	"./socialGaming.svg": 415,
	"./sportsbook.svg": 416,
	"./springPro.svg": 417,
	"./statistics.svg": 418,
	"./sweepstake.svg": 419,
	"./talisman.svg": 420,
	"./terminal.svg": 421,
	"./virtualSports.svg": 422,
	"./vivaroGo.svg": 423,
	"./vrCasino.svg": 424,
	"./vrExpo.svg": 425
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 396;